import DOMPurify from "dompurify";

/**
 * Makes stored message HTML safe to render.
 *
 * Message bodies are user-supplied and the BFF stores them exactly as sent,
 * so a member could post `<img src=x onerror=…>` and run script in everyone
 * else's session. Every `dangerouslySetInnerHTML` of message content goes
 * through here: formatting survives; scripts, event handlers, iframes, forms,
 * inline styles and links other than http(s)/mailto/relative do not.
 */
const ALLOWED_TAGS = [
    "a", "b", "strong", "i", "em", "u", "s", "del", "ins", "mark", "small", "sub", "sup",
    "p", "br", "hr", "span", "div", "blockquote", "code", "pre",
    "ul", "ol", "li", "h1", "h2", "h3", "h4", "h5", "h6",
    "table", "thead", "tbody", "tr", "th", "td", "img"
];
const ALLOWED_ATTR = ["href", "title", "alt", "src", "class", "target", "rel", "colspan", "rowspan"];
const ALLOWED_URI = /^(?:https?:|mailto:|data:image\/(?:png|gif|jpe?g|webp);base64,|\/(?!\/)|#)/i;

let hooked = false;

function ensureLinkHook() {
    if (hooked) return;
    hooked = true;
    // Links open in a new tab without giving the target page a handle on ours.
    DOMPurify.addHook("afterSanitizeAttributes", (node) => {
        if (node.tagName === "A") {
            node.setAttribute("target", "_blank");
            node.setAttribute("rel", "noopener noreferrer");
        }
    });
}

export function sanitizeHtml(html: string | null | undefined): string {
    if (!html) return "";
    ensureLinkHook();
    return DOMPurify.sanitize(html, {
        ALLOWED_TAGS,
        ALLOWED_ATTR,
        ALLOWED_URI_REGEXP: ALLOWED_URI
    });
}
